import { gql } from '@apollo/client'
// TODO: Essa query deve mudar de nome pois o real get course é o getCourseContent
// Essa query está relacionada a paginação de conteúdos de um módulo
// Provavelmente deve ser renomeada para GET_MODULE_COURSE_CONTENTS
// e também ajustar o nome do arquivo e os locais onde é chamada
export const GET_COURSE_CONTENTS = gql`
  query getModulesCourseContents(
    $id: ID!
    $moduleId: ID
    $offset: Int!
    $limit: Int!
  ) {
    course(id: $id) {
      id
      courseModules(id: $moduleId) {
        nodes {
          id
          name
          available
          parentCourseModule {
            id
          }
          courseContents(pagination: { offset: $offset, limit: $limit }) {
            nodes {
              id
              available
              lesson {
                id
                title
                releaseAt
                releaseAfter
                courseContentId
                lockAt
                lockAfter
                createdAt
                activity {
                  id
                  examQuestionsCount
                }
                media {
                  id
                  type
                  duration
                  hostKey
                  host
                  fileExt
                  text
                  organizationUuid
                }
                coverImage {
                  cdnFileUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
